import axios from 'axios';
import { getApiErrorMessage } from '../utils/apiError';

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

// Add a request interceptor to dynamically get token
axiosInstance.interceptors.request.use(
  config => {
    // Get fresh token on each request
    const token = window.localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // condition for UnAuthorized Data
    if (error.response?.status === 401) {
      window.localStorage.removeItem('token'); // Clear invalid token
      // Don't redirect if already on the login page to avoid redirect loops
      if (!window.location.pathname.includes('/login')) {
        window.location.href = `${import.meta.env.VITE_LOGIN_URL}`;
      }
    }
    // Attach a normalized message so every onError handler can just use error.message
    const message = getApiErrorMessage(error);
    error.message = message;
    return Promise.reject(error);
  }
);

export default axiosInstance;
